module.exports = __webpack_public_path__ + "img/paypal.024d9499.svg";